<template>
  <v-container fluid>
    <!-- Header con título mejorado -->
    <v-row no-gutters justify="center" class="mt-n6">
      <div class="inventory-title-section">
        <v-icon large class="pr-1 pb-2" color="primary">rule</v-icon>
        <span style="font-size: 34px; color: #616161">Inventario</span>
        <v-chip v-if="
          selectedWarehouseInfo &&
          selectedWarehouseInfo.isParent &&
          selectedWarehouseInfo.name
        " class="ml-3" color="primary" outlined>
          <v-icon left small>mdi-warehouse</v-icon>
          Vista Consolidada: {{ selectedWarehouseInfo.name }}
        </v-chip>
      </div>
    </v-row>

    <!-- Header con filtros -->
    <HeaderFilters class="mt-n1" v-if="showHeader" @refreshWarehouse="getArticlesInWarehouse"
      :filter_default="defaultFilters" :show_all_option="true" :show_advanced_filters="true" />

    <div v-if="!loading">
      <v-layout align-start>
        <v-flex>
          <v-card class="mt-4">
            <v-card-text>
              <!-- Chips de filtros activos -->
              <v-chip-group class="d-flex flex-wrap" column>
                <v-chip v-for="(value, key) in activeFilters" :key="key" @click:close="resetFilter(key)" class="ma-1"
                  color="primary" dense outlined close>
                  {{
                    filters_data[key] && filters_data[key].description
                      ? filters_data[key].description
                      : ""
                  }}
                  {{
                    filters_data[key] && filters_data[key].name
                      ? filters_data[key].name
                      : ""
                  }}
                </v-chip>
              </v-chip-group>

              <!-- Alerta informativa para almacenes padre -->
              <v-alert v-if="
                selectedWarehouseInfo &&
                selectedWarehouseInfo.isParent &&
                selectedWarehouseInfo.name
              " type="info" outlined prominent class="mb-4 warehouse-info-alert">
                <div class="d-flex align-center">
                  <v-icon left color="info">mdi-warehouse</v-icon>
                  <div class="flex-grow-1">
                    <div class="font-weight-bold">
                      Vista consolidada: {{ selectedWarehouseInfo.name }}
                    </div>
                    <div class="mt-1">
                      Mostrando inventario total de todos los almacenes hijos. Expandir
                      filas para ver distribución detallada por almacén.
                    </div>
                  </div>
                  <v-chip color="info" outlined small>
                    {{ getInventory.length }} artículos
                  </v-chip>
                </div>
              </v-alert>

              <!-- Tabla principal -->

              <v-data-table :headers="headerArticle" :search="search" :items="articles" :loading="loading"
                class="inventory-data-table" show-expand :expanded.sync="expanded" item-key="item_id"
                :server-items-length="pagination.total_items" :page.sync="pagination.current_page"
                :items-per-page.sync="pagination.per_page" :footer-props="{
                  'items-per-page-options': [10, 25, 50, 100],
                  'page-text': `${pagination.current_page} de ${pagination.total_pages}`,
                  'items-per-page-text': 'Elementos por página:',
                }" @update:page="onPageChange" @update:items-per-page="onItemsPerPageChange">
                <!-- Toolbar superior -->
                <template v-slot:top>
                  <v-toolbar flat class="inventory-toolbar">
                    <v-toolbar-title class="toolbar-title">
                      <v-icon left>mdi-package-variant</v-icon>
                      Artículos
                    </v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-chip color="primary" outlined>
                      <span class="font-weight-bold">{{ getInventory.length }}</span>
                    </v-chip>
                    <v-spacer></v-spacer>

                    <!-- Campo de búsqueda -->
                    <v-row>
                      <v-col md="8">

                        <div>
                          <v-text-field class="search-field" v-model="search" append-icon="mdi-magnify" label="Buscar"
                            single-line outlined hide-details dense clearable></v-text-field>

                          <div class="debounce-progress-bar-container"
                            v-show="debounceProgress > 0 && debounceProgress < 100">
                            <div class="debounce-progress-bar" :style="{ width: debounceProgress + '%' }"></div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>

                    <v-spacer></v-spacer>

                    <!-- Botón de filtros -->

                    <v-divider class="mx-3" inset vertical></v-divider>

                    <!-- Menú de descarga -->
                    <v-menu bottom origin="center center" transition="scale-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ml-2" color="success" outlined v-bind="attrs" v-on="on">
                          Descargar
                          <v-icon class="ml-2">mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="downloadPDF">
                          <v-list-item-icon>
                            <v-icon color="red">mdi-file-pdf-box</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>PDF</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="exportExcel()">
                          <v-list-item-icon>
                            <v-icon color="success">mdi-file-excel-box</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>EXCEL</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-toolbar>
                </template>

                <!-- Columna de imagen -->
                <template v-slot:[`item.item_image`]="{ item }">
                  <v-avatar size="40" class="ma-2">
                    <v-img v-if="
                      item.item_image && item.item_image !== 'image-not-aviable.jpg'
                    " :src="item.item_image" :alt="item.item_name"></v-img>
                    <v-icon v-else color="grey lighten-1">mdi-package-variant</v-icon>
                  </v-avatar>
                </template>

                <!-- Columna de artículo -->
                <template v-slot:[`item.item_name`]="{ item }">
                  <div>
                    <div class="font-weight-medium" style="max-width: 400px">
                      {{ item.item_name }}
                    </div>
                    <div class="caption grey--text">
                      {{ item.code || "Sin código" }}
                    </div>
                  </div>
                </template>

                <!-- Columna de disponible mejorada -->
                <template v-slot:[`item.quantity`]="{ item }">
                  <div class="d-flex align-center">
                    <v-chip small :color="getStockColor(item.total_quantity || item.quantity)" text-color="white"
                      class="mr-2">
                      {{ item.total_quantity || item.quantity || 0 }}
                    </v-chip>
                    <span class="caption">{{ item.unit_name || "Sin unidad" }}</span>
                    <!-- Indicador de distribución múltiple -->
                    <v-tooltip top v-if="
                      item.warehouse_distribution &&
                      item.warehouse_distribution.length > 1
                    ">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small color="info" class="ml-1" v-bind="attrs" v-on="on">
                          mdi-warehouse-outline
                        </v-icon>
                      </template>
                      <span>Distribuido en
                        {{ item.warehouse_distribution.length }} almacenes</span>
                    </v-tooltip>
                  </div>
                </template>

                <!-- Columna de valor del inventario -->
                <template v-slot:[`item.value_inventory`]="{ item }">
                  <div class="text-right">
                    <div class="font-weight-medium text-success">
                      {{ currencyFormat(calculateItemValue(item)) }}
                    </div>
                    <div class="d-flex align-center justify-end">
                      <span class="caption grey--text mr-1">
                        {{ getBusinessCurrency().currency_code }}
                      </span>
                      <country-flag :country="getFlag(getBusinessCurrency().currency_id)" size="small" />
                    </div>
                  </div>
                </template>

                <!-- Columna de costo unitario -->
                <template v-slot:[`item.cost_price`]="{ item }">
                  <div class="text-right">
                    <div class="font-weight-medium">
                      {{ currencyFormat(getItemCostPrice(item)) }}
                    </div>
                    <div class="caption grey--text">
                      {{ getBusinessCurrency().currency_code }}
                    </div>
                  </div>
                </template>

                <!-- Columna de transformar -->
                <template v-slot:[`item.transform`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-if="hasFeature('INV-011')" icon color="primary" v-bind="attrs" v-on="on" @click="transform(item)"
                        :disabled="!canTransform(item)">
                        <v-icon>mdi-swap-horizontal</v-icon>
                      </v-btn>
                    </template>
                    <span>Transformar artículo</span>
                  </v-tooltip>
                </template>

                <!-- Columna de historial -->
                <template v-slot:[`item.show`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon color="info" v-bind="attrs" v-on="on" @click="viewHistory(item)">
                        <v-icon>mdi-history</v-icon>
                      </v-btn>
                    </template>
                    <span>Ver historial del artículo</span>
                  </v-tooltip>
                </template>

                <!-- Botón de expandir -->
                <template v-slot:[`item.data-table-expand`]="{ item, expand, isExpanded }">
                  <v-btn v-if="
                    item.warehouse_distribution &&
                    item.warehouse_distribution.length > 1
                  " icon small @click="expand(!isExpanded)" color="primary">
                    <v-icon>{{
                      isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
                    }}</v-icon>
                  </v-btn>
                </template>

                <!-- Contenido expandido - Distribución por almacén -->
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="pa-0">
                    <v-container>
                      <v-card flat class="warehouse-distribution-card">
                        <v-card-title class="py-3 warehouse-distribution-header">
                          <v-icon left small color="primary">mdi-warehouse</v-icon>
                          <span class="subtitle-2">Distribución por Almacén - {{ item.item_name }}</span>
                          <v-spacer></v-spacer>
                          <v-chip small color="info" outlined>
                            {{ item.warehouse_distribution.length }} ubicaciones
                          </v-chip>
                        </v-card-title>

                        <v-simple-table dense class="warehouse-distribution-table">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Ubicación</th>
                                <th class="text-left">Ruta</th>
                                <th class="text-center">Cantidad</th>
                                <th class="text-right">Valor</th>
                                <th class="text-center">Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="warehouse in item.warehouse_distribution" :key="warehouse.warehouse_id"
                                class="warehouse-distribution-row">
                                <td>
                                  <div class="d-flex align-center">
                                    <v-icon small :color="warehouse.is_parent_warehouse ? 'primary' : 'grey'
                                      " class="mr-2">
                                      {{
                                        warehouse.is_parent_warehouse
                                          ? "mdi-warehouse"
                                          : "mdi-package-variant-closed"
                                      }}
                                    </v-icon>
                                    <div>
                                      <div class="font-weight-medium">
                                        {{ warehouse.warehouse_name || "Sin nombre" }}
                                      </div>
                                      <div class="caption grey--text" v-if="warehouse.warehouse_address">
                                        {{ warehouse.warehouse_address }}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div class="caption">
                                    {{ warehouse.warehouse_path || "Sin ruta" }}
                                  </div>
                                </td>
                                <td class="text-center">
                                  <v-chip x-small :color="getStockColor(warehouse.quantity || 0)" text-color="white">
                                    {{ warehouse.quantity || 0 }}
                                  </v-chip>
                                </td>
                                <td class="text-right">
                                  <span class="font-weight-medium">
                                    {{
                                      currencyFormat(
                                        (warehouse.quantity || 0) * getItemCostPrice(item)
                                      )
                                    }}
                                  </span>
                                </td>
                                <td class="text-center">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon x-small color="info" v-bind="attrs" v-on="on"
                                        @click="viewWarehouseHistory(item, warehouse)">
                                        <v-icon small>mdi-history</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Ver historial en este almacén</span>
                                  </v-tooltip>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-card>
                    </v-container>
                  </td>
                </template>

                <!-- Footer con total -->
                <template slot="footer">
                  <v-row justify="end" class="inventory-footer">
                    <v-col cols="12" md="2">
                      <span class="total-label">TOTAL</span>
                    </v-col>
                    <v-col cols="12" md="2">
                      <div class="total-amount">
                        {{ currencyFormat(totalCost) }}
                        <span v-if="filters && filters.location" class="currency-info ml-2">
                          {{ getBusinessCurrency().currency_code }}
                          <country-flag :country="getFlag(getBusinessCurrency().currency_id)" size="small"
                            class="ml-1" />
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </template>

                <!-- Loading state -->
                <template v-slot:loading>
                  <div class="text-center pa-4">
                    <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
                    <div class="mt-2">Cargando inventario...</div>
                  </div>
                </template>

                <!-- No data state -->
                <template v-slot:no-data>
                  <div class="text-center pa-8">
                    <v-icon size="80" color="grey lighten-2">mdi-package-variant-off</v-icon>
                    <h3 class="mt-4 mb-2">No se encontraron artículos</h3>
                    <p class="grey--text">
                      Verifica los filtros seleccionados o el almacén
                    </p>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- Dialog de filtros -->
      <ArticleFilters @returnFilters="filtrar" @closeDialog="dialogFilters = false" :showDialog="dialogFilters" />

      <!-- Dialog de historial mejorado -->
      <v-dialog v-model="dialogHistory" max-width="80%" persistent>
        <v-card class="history-dialog">
          <v-card-title class="history-header">
            <v-icon left color="white">mdi-history</v-icon>
            <span class="headline">Historial de {{ historyName.slice(0, 60) }}</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogHistory = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="py-4">
            <!-- <v-row no-gutters justify="center" class="mb-4">
              <div class="history-article-info">
                <h3 class="article-name">{{ historyName }}</h3>
                <p class="article-details grey--text">
                  {{ selectedWarehouseInfo ? selectedWarehouseInfo.name : 'Almacén específico' }}
                </p>
              </div>
            </v-row> -->

            <v-card outlined>
              <v-data-table :headers="headerHistory" :search="searchHistory" :items="itemsHistory" height="60vh"
                fixed-footer key="item_key" fixed-header :loading="loading_history" class="history-table">
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>Registros de Movimiento</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-chip color="primary" outlined>{{ itemsHistory.length }}</v-chip>
                    <v-spacer></v-spacer>
                    <v-col md="3">
                      <v-text-field class="text-xs-center" v-model="searchHistory" append-icon="mdi-magnify"
                        label="Buscar en historial" single-line hide-details outlined dense></v-text-field>
                    </v-col>
                    <v-col md="3">
                      <v-autocomplete v-model="warehouse_history" @change="viewHistory(null)" :items="itemsWarehouse.filter(
                        (element) => element.location_id == filters.location.id
                      )
                        " color="cyanText" label="Almacen" item-value="id" item-text="name"
                        prepend-inner-icon="business" outlined hide-details :disabled="loading_history" required dense>
                      </v-autocomplete>
                    </v-col>
                    <v-btn color="success" @click="downloadHistoryXLSX" :disabled="loading_history || itemsHistory.length === 0" class="ml-2">
                      <v-icon left>mdi-file-excel</v-icon>
                      Descargar
                    </v-btn>
                  </v-toolbar>
                </template>

                <!-- Cantidad con color -->
                <template v-slot:[`item.quantity`]="{ item }">
                  <v-chip small :color="parseFloat(item.quantity) > 0 ? 'success' : 'error'" text-color="white">
                    {{ parseFloat(item.quantity) > 0 ? "+" : "" }}{{ item.quantity }}
                  </v-chip>
                </template>

                <!-- Enlaces clickeables para ver origen -->
                <template v-slot:[`item.code`]="{ item }">
                  <v-hover v-slot="{ hover }">
                    <span @click="viewOrigin(item)" class="origin-link" :class="{ 'origin-link--hover': hover }">
                      {{ item.code }}
                    </span>
                  </v-hover>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog de transformación -->
      <ArticleTransform v-if="dialogTransform" :showDialog="dialogTransform" :article="itemTransform"
        @closeDialog="closeTransform" />
    </div>

    <!-- Loading principal -->
    <div class="text-center pt-5 pb-5 font-weight-bold" v-else>
      <v-progress-circular indeterminate color="primary" size="60"></v-progress-circular>
      <div class="mt-3">Cargando inventario...</div>
    </div>
  </v-container>
</template>

<script>
import HeaderFilters from "@/components/Inventory/HeaderFilters.vue";
import ArticleFilters from "@/components/Inventory/ArticleFilters.vue";
import ArticleTransform from "@/components/Inventory/ArticleTransform.vue";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from "exceljs";

export default {
  data: () => ({
    loading: false,
    dialogTransform: false,
    expanded: [], // Para controlar filas expandidas

    // Paginación
    pagination: {
      current_page: 1,
      per_page: 25,
      total_items: 0,
      total_pages: 0,
      has_next_page: false,
      has_prev_page: false,
      next_page: null,
      prev_page: null,
    },
    totalCost: 0,

    // Filtros
    filters: {
      location: { catalogue_id: "", id: "" },
      business: "",
      warehouse: { id: null, name: null, isParent: false },
    },
    defaultFilters: [],
    computeFilters: {
      unit: 0,
      item_type: 0,
      item_category: [],
      account_category: 0,
      tax_type: 0,
      inventory_product: 0,
      negative_sale: 0,
    },

    // Dialogs
    dialogFilters: false,
    dialogAdjunct: false,
    dialogHistory: false,

    // Data
    newQuantity: 0,
    lastFilters: {},
    articles: [],
    search: "",
    searchHistory: "",
    searchTimeout: null,
    debounceInterval: 1000, // 1 segundo
    debounceProgress: 0,    // Usado en el HTML/CSS
    progressInterval: null, // Usado para animar la barra

    // Headers mejorados
    headerArticle: [
      //{ text: "", align: "start", value: "item_image", width: "60px", sortable: false },
      { text: "ID", value: "item_id", width: "80px" },
      { text: "Artículo", value: "item_name", width: "25%" },
      { text: "Tipo", value: "item_type_name", width: "120px" },
      { text: "Unidad de medida", value: "unit_name", width: "120px" },
      { text: "Categoría", value: "item_category_name", width: "150px" },
      { text: "Disponible", value: "quantity", width: "120px", align: "center" },
      { text: "C/U", value: "cost_price", align: "end", width: "100px" },
      { text: "Valor", value: "value_inventory", align: "end", width: "120px" },
      {
        text: "Transformar",
        value: "transform",
        sortable: false,
        width: "100px",
        align: "center",
      },
      {
        text: "Historial",
        value: "show",
        sortable: false,
        width: "100px",
        align: "center",
      },
      { text: "", value: "data-table-expand", sortable: false, width: "50px" },
    ],

    headerHistory: [
      { text: "Fecha", value: "effective_date", width: "150px" },
      { text: "Cantidad", value: "quantity", align: "center", width: "100px" },
      { text: "Concepto", value: "concept", align: "center", width: "120px" },
      { text: "Codigo", value: "code", align: "center", width: "120px" },
      // { text: "Ajuste", value: "adjustment_id", align: "center", width: "120px" },
      // { text: "Transferencia", value: "transfer_id", align: "center", width: "120px" },
      // { text: "Transformación", value: "item_transformation_id", align: "center", width: "120px" },
      // { text: "Nota", value: "note_id", align: "center", width: "120px" },
    ],

    // Otros
    itemsHistory: [],
    itemsBussines: [],
    showAll: true,
    articleSelected: { item_name: "", available: 0 },
    historyName: "",
    itemTransform: {
      article_id: null,
      business_unit_id: null,
      location_id: null,
      warehouse_id: null,
    },
    showHeader: false,
    filters_data: {},
    itemsWarehouse: [],
    loading_history: false,
    warehouse_history: null,
    article_to_search_history: null,

    // Arrays para filtros avanzados
    units: [],
    itemTypes: [],
    categorys: [],
    accountCategorys: [],
    taxes: [],
  }),

  components: {
    HeaderFilters,
    ArticleFilters,
    ArticleTransform,
  },

  computed: {
    activeFilters() {
      return Object.fromEntries(
        Object.entries(this.computeFilters).filter(([_, value]) => value > 0)
      );
    },

    selectedWarehouseInfo() {
      if (!this.filters || !this.filters.warehouse) {
        return null;
      }
      return this.filters.warehouse;
    },

    // Computa los artículos en la tabla según los filtros y estructura jerárquica
    getInventory() {
      if (!this.filters || !this.filters.warehouse || !this.articles) {
        return [];
      }

      let articles = [];

      for (let item of this.articles) {
        if (this.validateFilter(item)) {
          continue;
        }

        // Verificar que item_in_warehouses existe
        if (!item.item_in_warehouses || !Array.isArray(item.item_in_warehouses)) {
          // Si no hay datos de almacén, crear un item con cantidad 0
          if (this.showAll) {
            articles.push(this.createArticleItem(item, [], 0));
          }
          continue;
        }

        // Procesar inventario según el tipo de almacén seleccionado
        let warehouseDistribution = [];
        let totalQuantity = 0;

        if (this.filters.warehouse.id === 0) {
          // Todos los almacenes - mostrar distribución completa
          warehouseDistribution = this.processAllWarehouses(item);
          totalQuantity = warehouseDistribution.reduce(
            (sum, w) => sum + (parseFloat(w.quantity) || 0),
            0
          );
        } else if (this.filters.warehouse.isParent) {
          // Almacén padre - mostrar distribución de hijos
          warehouseDistribution = this.processParentWarehouse(item);
          totalQuantity = warehouseDistribution.reduce(
            (sum, w) => sum + (parseFloat(w.quantity) || 0),
            0
          );
        } else {
          // Almacén individual (puede ser hijo o independiente)
          const available = item.item_in_warehouses.filter(
            (element) => element && element.warehouse_id == this.filters.warehouse.id
          );

          // Validación segura del array available
          totalQuantity =
            available && available.length > 0 && available[0]
              ? parseFloat(available[0].quantity) || 0
              : 0;

          if (available && available.length > 0 && available[0]) {
            warehouseDistribution = [
              {
                warehouse_id: this.filters.warehouse.id,
                warehouse_name:
                  this.filters.warehouse.name || `Almacén ${this.filters.warehouse.id}`,
                quantity: totalQuantity,
                warehouse_path:
                  this.filters.warehouse.path ||
                  this.filters.warehouse.name ||
                  `Almacén ${this.filters.warehouse.id}`,
                warehouse_address: available[0].warehouse_address || "",
                is_parent_warehouse: false,
              },
            ];
          }
        }

        // Filtrar por existencia si es necesario
        if (!this.showAll && totalQuantity === 0) {
          continue;
        }

        articles.push(this.createArticleItem(item, warehouseDistribution, totalQuantity));
      }

      return articles;
    },
  },

  watch: {
    showAll: {
      handler() {
        if (this.filters && this.filters.warehouse && this.filters.warehouse.id) {
          this.getArticlesInWarehouse(this.filters, false);
        }
      },
      immediate: false,
    },
    computeFilters: {
      handler() {
        if (this.filters && this.filters.warehouse && this.filters.warehouse.id) {
          this.getArticlesInWarehouse(this.filters, false);
        }
      },
      deep: true,
      immediate: false,
    },
    // search: {
    //   handler(newVal, oldVal) {

    //     // Limpiar timeout anterior si existe
    //     if (this.searchTimeout) {
    //       clearTimeout(this.searchTimeout);
    //     }

    //     // Aplicar debounce para evitar demasiadas llamadas al API
    //     this.searchTimeout = setTimeout(() => {
    //       // Resetear paginación al buscar
    //       this.pagination.current_page = 1;

    //       // Usar lastFilters (de HeaderFilters) si están disponibles, sino usar this.filters
    //       const filtersToUse =
    //         this.lastFilters && Object.keys(this.lastFilters).length > 0
    //           ? this.lastFilters
    //           : this.filters;

    //       // Ejecutar búsqueda si hay filtros válidos (incluyendo warehouse.id === 0 para "Todos")
    //       if (
    //         filtersToUse &&
    //         filtersToUse.warehouse &&
    //         (filtersToUse.warehouse.id || filtersToUse.warehouse.id === 0)
    //       ) {
    //         this.getArticlesInWarehouse(filtersToUse, false);
    //       } else {
    //         console.warn("No valid filters found for search. Filters:", filtersToUse);
    //       }
    //     }, 1000); // Esperar 300ms después de que el usuario deje de escribir
    //   },
    //   immediate: false,
    // },
    search: {
      handler(newVal, oldVal) {
        // 1. Limpiar cualquier timeout o interval anterior
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        if (this.progressInterval) {
          clearInterval(this.progressInterval);
          this.debounceProgress = 0;
        }

        // 2. Iniciar el Interval para la barra de progreso
        const startTime = Date.now();
        this.progressInterval = setInterval(() => {
          const elapsed = Date.now() - startTime;
          let progress = Math.min(100, (elapsed / this.debounceInterval) * 100);
          this.debounceProgress = progress;

          if (progress >= 100) {
            clearInterval(this.progressInterval);
            this.progressInterval = null;
          }
        }, 50);

        // 3. Establecer el Debounce Timeout (¡Asegúrate de que la lógica de filtros esté AQUÍ!)
        this.searchTimeout = setTimeout(() => {

          // --- INICIO: Lógica movida dentro del setTimeout ---
          // Detener y resetear el intervalo de progreso
          if (this.progressInterval) {
            clearInterval(this.progressInterval);
          }
          this.debounceProgress = 100;

          // Resetear paginación al buscar
          this.pagination.current_page = 1;

          // **¡CORRECCIÓN! Declarar filtersToUse DENTRO del timeout**
          const filtersToUse =
            this.lastFilters && Object.keys(this.lastFilters).length > 0
              ? this.lastFilters
              : this.filters;

          // Ejecutar búsqueda si hay filtros válidos
          if (
            filtersToUse &&
            filtersToUse.warehouse &&
            (filtersToUse.warehouse.id || filtersToUse.warehouse.id === 0)
          ) {
            this.getArticlesInWarehouse(filtersToUse, false);
          } else {
            console.warn("No valid filters found for search. Filters:", filtersToUse);
          }

          // Limpiar timeout y la barra después de la llamada
          this.searchTimeout = null;
          setTimeout(() => { this.debounceProgress = 0; }, 200);
          // --- FIN: Lógica movida dentro del setTimeout ---

        }, this.debounceInterval);
      },
      immediate: false,
    }
  },

  mounted() {
    if (this.$route.params.filtersDefault == undefined) {
      this.showHeader = true;
    }

    // Inicializar filtros desde el store si no están definidos
    if (this.$store.state.app.filters && this.$store.state.app.filters.warehouse) {
      this.filters.warehouse = this.$store.state.app.filters.warehouse;
    }

    this.getArticlesInWarehouse();
  },

  methods: {
    createArticleItem(item, warehouseDistribution, totalQuantity) {
      return {
        item_id: item.item_id || 0,
        item_name: item.item_name || "Sin nombre",
        unit_name: item.unit_name || "Sin unidad",
        item_type_name: item.item_type_name || "Sin tipo",
        cost_price: item.cost_price || 0,
        quantity: totalQuantity,
        total_quantity: totalQuantity,
        inventory_product: item.inventory_product || false,
        negative_sale: item.negative_sale || false,
        item_image: item.item_image || "image-not-aviable.jpg",
        item_currencies: item.item_currencies || [],
        item_category_name: item.item_category_name || "Sin categoría",
        code: item.code || "Sin código",
        account_categorie: item.account_categories?.name || "Sin cuenta",
        warehouse_distribution: warehouseDistribution,
        raw_item: item,
      };
    },
    // ================================
    // MÉTODOS PRINCIPALES MEJORADOS
    // ================================

    async getArticlesInWarehouse(filters, resetPagination = true) {
    

      this.loading = true;
      this.lastFilters = filters;

      // Reset pagination if needed
      if (resetPagination) {
        this.pagination.current_page = 1;
      }

      this.itemsBussines = Object.assign([], this.$store.state.auth.bussines_units);

      // Manejar filtros por defecto desde rutas
      if (this.$route.params.filtersDefault != undefined) {
   
        this.filters = Object.assign({}, this.$route.params.filtersDefault);
        this.defaultFilters = [Object.assign({}, this.$route.params.filtersDefault)];
        this.$route.params.filtersDefault = undefined;

        if (this.filters.warehouse == undefined || this.filters.warehouse.id == null) {
          console.error('📦 ❌ Warehouse inválido en filtros por defecto');
          this.loading = false;
          return;
        }
      } else {
        this.filters = filters;
        if (this.filters == undefined) {
          this.loading = false;
          return;
        }

        // Inicializar warehouse desde el store si no está definido
        if (
          (this.filters.warehouse == undefined || this.filters.warehouse.id == null) &&
          this.$store.state.app.filters &&
          this.$store.state.app.filters.warehouse
        ) {
          this.filters.warehouse = this.$store.state.app.filters.warehouse;
        }

        if (this.filters.warehouse == undefined || this.filters.warehouse.id == null) {
          this.$toast.warning("Escoja un almacén!");
          this.loading = false;
          return;
        }

        // Actualizar computeFilters con los filtros avanzados del HeaderFilters
        if (filters.unit !== undefined) this.computeFilters.unit = filters.unit;
        if (filters.item_type !== undefined)
          this.computeFilters.item_type = filters.item_type;
        if (filters.item_category !== undefined)
          this.computeFilters.item_category = filters.item_category;
        if (filters.account_category !== undefined)
          this.computeFilters.account_category = filters.account_category;
        if (filters.tax_type !== undefined)
          this.computeFilters.tax_type = filters.tax_type;
        if (filters.inventory_product !== undefined)
          this.computeFilters.inventory_product = filters.inventory_product;
        if (filters.negative_sale !== undefined)
          this.computeFilters.negative_sale = filters.negative_sale;
        if (filters.showAll !== undefined) this.showAll = filters.showAll;
        // Cargar datos de filtros y actualizar filters_data para mostrar chips correctamente
        await this.loadFilterData();
        this.updateFiltersData();

        this.get_warehouses();
      }

      // Helper para extraer location_id
      const getLocationId = (location) => {
        if (!location) return null;
        if (typeof location === 'object') {
          return location.id ?? location.value ?? null;
        }
        return location;
      };

      const locationId = getLocationId(this.filters.location);


      try {
        // Llamada al API con parámetros de paginación
        const requestData = {
          item_type_id: '1,3,5',
          date: this.filters.dateEnd,
          business_unit_id: this.filters.business,
          location_id: locationId,
          warehouse_id: this.filters.warehouse.id,
          is_parent: this.filters.warehouse.isParent || false,
          is_now: true,
          page: this.pagination.current_page,
          limit: this.pagination.per_page,
          search: this.search || "",
          category_id:
            this.computeFilters.item_category.length > 0
              ? this.computeFilters.item_category.join(",")
              : null,
          // Agregar filtros adicionales
          // item_type_id:
          //   this.computeFilters.item_type > 0 ? this.computeFilters.item_type : null,
          unit_id: this.computeFilters.unit > 0 ? this.computeFilters.unit : null,
          account_category_id:
            this.computeFilters.account_category > 0
              ? this.computeFilters.account_category
              : null,
          tax_type_id:
            this.computeFilters.tax_type > 0 ? this.computeFilters.tax_type : null,
          inventory_product: this.computeFilters.inventory_product,
          negative_sale: this.computeFilters.negative_sale,
          show_all: this.showAll || false,
        };
        const request = await this.api_Post("inventory/inventory_value", requestData);
        const data = await request.json();

        if (request.status == 200) {
          // Procesar datos de la respuesta
          let items = data.data || [];

          // Procesar cada item para el formato esperado por la tabla
          const processedItems = [];
          for (let item of items) {
            // Procesar imagen
            item.item_image = "image-not-aviable.jpg";
            if (item.image_json != null) {
              item.item_image = this.get_storage(item.image_json);
            }

            // Procesar distribución de almacenes
            let warehouseDistribution = [];
            let totalQuantity = 0;

            if (this.filters.warehouse.id === 0) {
              // Todos los almacenes
              warehouseDistribution = this.processAllWarehouses(item);
              totalQuantity = warehouseDistribution.reduce(
                (sum, w) => sum + (w.quantity || 0),
                0
              );
            } else if (this.filters.warehouse.isParent) {
              // Almacén padre
              warehouseDistribution = this.processParentWarehouse(item);
              totalQuantity = warehouseDistribution.reduce(
                (sum, w) => sum + (w.quantity || 0),
                0
              );
            } else {
              // Almacén individual
              const available = item.item_in_warehouses?.filter(
                (element) => element.warehouse_id == this.filters.warehouse.id
              );
              totalQuantity = available.length > 0 ? available[0].quantity : 0;

              if (available.length > 0) {
                warehouseDistribution = [
                  {
                    warehouse_id: this.filters.warehouse.id,
                    warehouse_name: this.filters.warehouse.name,
                    quantity: totalQuantity,
                    warehouse_path:
                      this.filters.warehouse.path || this.filters.warehouse.name,
                    warehouse_address: "",
                    is_parent_warehouse: false,
                  },
                ];
              }
            }

            // Filtrar por existencia si es necesario
            if (!this.showAll && totalQuantity === 0) {
              continue;
            }

            processedItems.push({
              item_id: item.item_id || 0,
              item_name: item.item_name || "Sin nombre",
              unit_name: item.unit_name || "Sin unidad",
              item_type_name: item.item_type_name || "Sin tipo",
              cost_price: item.cost_price || 0,
              quantity: totalQuantity,
              total_quantity: totalQuantity,
              inventory_product: item.inventory_product || false,
              negative_sale: item.negative_sale || false,
              item_image: item.item_image || "image-not-aviable.jpg",
              item_currencies: item.item_currencies || [],
              item_category_name: item.item_category_name || "Sin categoría",
              code: item.code || "Sin código",
              account_categorie: item.account_categories?.name || "Sin cuenta",
              warehouse_distribution: warehouseDistribution,
              raw_item: item,
            });
          }

          this.articles = processedItems;

          // Actualizar información de paginación
          if (data.pagination) {
            this.pagination = {
              current_page: data.pagination.current_page,
              per_page: data.pagination.per_page,
              total_items: data.pagination.total_items,
              total_pages: data.pagination.total_pages,
              has_next_page: data.pagination.has_next_page,
              has_prev_page: data.pagination.has_prev_page,
              next_page: data.pagination.next_page,
              prev_page: data.pagination.prev_page,
            };
          }

          // Actualizar costo total
          this.totalCost = data.summary?.total_cost || 0;
        } else {
          this.$toast.error(data.error);
        }
      } catch (error) {
        console.error("Error loading inventory:", error);
        this.$toast.error("Error al cargar el inventario");
      }

      this.showHeader = true;
      this.loading = false;
    },
    async get_warehouses() {
      const warehouses = await this.api_Get("inventory/warehouse_items/" + 150);
      this.itemsWarehouse = await warehouses.json();
      this.warehouse_history = this.itemsWarehouse[0].id;
    },
    // ================================
    // MÉTODOS DE PROCESAMIENTO DE ALMACENES
    // ================================

    processAllWarehouses(item) {
      if (!item.item_in_warehouses || !Array.isArray(item.item_in_warehouses)) {
        return [];
      }

      return item.item_in_warehouses
        .filter((w) => w && typeof w === "object") // Filtrar elementos válidos
        .map((w) => ({
          warehouse_id: w.warehouse_id || 0,
          warehouse_name: w.warehouse_name || `Almacén ${w.warehouse_id || "Sin ID"}`,
          quantity: parseFloat(w.quantity) || 0,
          warehouse_path:
            w.warehouse_path ||
            `Business Unit ${w.business_unit_id || "N/A"} > Location ${w.location_id || "N/A"
            }`,
          warehouse_address: w.warehouse_address || "",
          is_parent_warehouse: w.is_parent_warehouse || false,
        }));
    },
    processItemFromBackend(item) {
      // Procesar imagen
      item.item_image = "image-not-aviable.jpg";
      if (item.image_json != null) {
        try {
          item.item_image = this.get_storage(item.image_json);
        } catch (error) {
          console.warn("Error processing image:", error);
          item.item_image = "image-not-aviable.jpg";
        }
      }

      // Validar y procesar item_in_warehouses
      if (!item.item_in_warehouses) {
        item.item_in_warehouses = [];
      } else if (typeof item.item_in_warehouses === "string") {
        try {
          item.item_in_warehouses = JSON.parse(item.item_in_warehouses);
        } catch (error) {
          console.warn("Error parsing item_in_warehouses:", error);
          item.item_in_warehouses = [];
        }
      }

      // Asegurar que es un array
      if (!Array.isArray(item.item_in_warehouses)) {
        item.item_in_warehouses = [];
      }

      // Validar cada elemento del array
      item.item_in_warehouses = item.item_in_warehouses.filter(
        (warehouse) =>
          warehouse &&
          typeof warehouse === "object" &&
          warehouse.warehouse_id !== undefined
      );

      return item;
    },
    processParentWarehouse(item) {
      if (!item.item_in_warehouses || !Array.isArray(item.item_in_warehouses)) {
        return [];
      }

      return item.item_in_warehouses
        .filter((w) => w && typeof w === "object") // Filtrar elementos válidos
        .map((w) => ({
          warehouse_id: w.warehouse_id || 0,
          warehouse_name: w.warehouse_name || `Almacén ${w.warehouse_id || "Sin ID"}`,
          quantity: parseFloat(w.quantity) || 0,
          warehouse_path:
            w.warehouse_path ||
            `${this.filters.warehouse.name || "Almacén Padre"} > Almacén ${w.warehouse_id || "Sin ID"
            }`,
          warehouse_address: w.warehouse_address || "",
          is_parent_warehouse: w.is_parent_warehouse || false,
        }));
    },

    // ================================
    // MÉTODOS DE UTILIDAD
    // ================================

    getBusinessCurrency() {
      const business = this.itemsBussines.find(
        (element) => element.value == this.filters.business
      );
      return business || { currency_code: "USD", currency_id: 1 };
    },

    getItemCostPrice(item) {
      const currency = this.getBusinessCurrency();
      const itemCurrency = item.item_currencies?.find(
        (element) => element.currency_id == currency.currency_id
      );
      return itemCurrency ? itemCurrency.cost_price : 0;
    },

    calculateItemValue(item) {
      const costPrice = this.getItemCostPrice(item);
      const quantity = item.total_quantity || item.quantity || 0;
      return costPrice * quantity;
    },

    getStockColor(quantity) {
      if (!quantity || quantity === 0) return "error";
      if (quantity < 10) return "warning";
      return "success";
    },

    canTransform(item) {
      const quantity = item.total_quantity || item.quantity || 0;
      return quantity > 0 || item.negative_sale;
    },

    get_storage(imageJson) {
      try {
        const imageData = JSON.parse(imageJson);
        return imageData.url || "image-not-aviable.jpg";
      } catch {
        return "image-not-aviable.jpg";
      }
    },

    // ================================
    // MÉTODOS DE HISTORIAL Y NAVEGACIÓN
    // ================================

    async viewHistory(itemArticle) {
      if (itemArticle != null) {
        this.article_to_search_history = itemArticle;
      }
      this.historyName = this.article_to_search_history.item_name;
      this.warehouse_history =
        this.filters.warehouse.id == 0
          ? this.warehouse_history
          : this.filters.warehouse.id;
      this.itemsHistory = [];

      try {
        this.loading_history = true;
        const request = await this.api_Post("inventory/article_history", {
          //
          item_id: this.article_to_search_history.item_id,
          warehouse_id: this.warehouse_history,
          is_parent: this.filters.warehouse.isParent || false,
        });

        const data = await request.json();

        if (request.status == 200) {
          for (let item of data) {
            let concept = "No definido",
              code = "-",
              id = null,
              type = 0;
            if (item.invoice_code) {
              id = item.invoice_id;
              code = item.invoice_code;
              concept = "FACTURA";
              type = 1;
            } else if (item.transfer_id) {
              id = item.transfer_id;
              code = item.transfer_code;
              concept = "TRANSFERENCIA";
              type = 2;
            } else if (item.adjustment_id) {
              id = item.adjustment_id;
              code = item.adjustment_code;
              concept = "AJUSTE";
              type = 3;
            } else if (item.item_transformation_id) {
              id = item.item_transformation_id;
              code = item.transformation_code;
              concept = "TRANSFORMACION";
              type = 4;
            } else if (item.invoice_note_id) {
              id = item.invoice_note_id;
              code = item.note_code;
              concept = "NOTA DE CREDITO";
              type = 5;
            } else if (item.item_conversion_id) {
              id = item.item_conversion_id;
              code = item.item_conversion_code;
              concept = "CONVERSION";
              type = 6;
            } else if (item.outflow_id) {
              id = item.outflow_id;
              code = item.outflow_code;
              concept = "SALIDA";
              type = 7;
            } else if (item.order_entry_id) {
              id = item.order_entry_id;
              code = item.order_entry_code;
              concept = "ENTRADA";
              type = 8;
            }
            this.itemsHistory.push({
              item_key: `${concept}-${type}-${code}-${id}`,
              quantity: parseFloat(item.quantity).toFixed(2),
              effective_date: moment(item.effective_date).format("DD/MM/YYYY HH:mm"),
              id: id,
              order_id: item.order_id,
              concept: concept,
              code: code,
              type: type,
            });
          }
          this.dialogHistory = true;
        } else {
          this.$toast.error(data.error);
        }
        console.log(this.itemsHistory)
      } catch (error) {
        console.error("Error loading history:", error);
        this.$toast.error("Error al cargar el historial");
      }
      this.loading_history = false;
    },

    async viewWarehouseHistory(item, warehouse) {
      // Ver historial específico de un almacén

      // Validar que warehouse no sea undefined y tenga un warehouse_id válido
      // También verifica que no sea la opción "Todos los almacenes"
      if (
        !warehouse ||
        !warehouse.warehouse_id ||
        warehouse.warehouse_id === "all" ||
        warehouse.warehouse_id === "-1"
      ) {
        this.$toast.warning(
          "Debe seleccionar un almacén específico para ver el historial"
        );
        return;
      }

      this.historyName = `${item.item_name} - ${warehouse.warehouse_name}`;
      this.itemsHistory = [];

      try {
        const request = await this.api_Post("inventory/article_history", {
          item_id: item.item_id,
          warehouse_id: warehouse.warehouse_id,
        });
        const data = await request.json();

        if (request.status == 200) {
          for (let item of data) {
            let concept = "No definido",
              code = "-",
              id = null,
              type = 0;
            if (item.invoice_code) {
              id = item.invoice_id;
              code = item.invoice_code;
              concept = "FACTURA";
              type = 1;
            } else if (item.transfer_id) {
              id = item.transfer_id;
              code = item.transfer_code;
              concept = "TRANSFERENCIA";
              type = 2;
            } else if (item.adjustment_id) {
              id = item.adjustment_id;
              code = item.adjustment_code;
              concept = "AJUSTE";
              type = 3;
            } else if (item.item_transformation_id) {
              id = item.item_transformation_id;
              code = item.transformation_code;
              concept = "TRANSFORMACION";
              type = 4;
            } else if (item.invoice_note_id) {
              id = item.invoice_note_id;
              code = item.note_code;
              concept = "NOTA DE CREDITO";
              type = 5;
            } else if (item.item_conversion_id) {
              id = item.item_conversion_id;
              code = item.item_conversion_code;
              concept = "CONVERSION";
              type = 6;
            } else if (item.outflow_id) {
              id = item.outflow_id;
              code = item.outflow_code;
              concept = "SALIDA";
              type = 7;
            } else if (item.order_entry_id) {
              id = item.order_entry_id;
              code = item.order_entry_code;
              concept = "ENTRADA";
              type = 8;
            }
            this.itemsHistory.push({
              item_key: `${concept}-${type}-${code}-${id}`,
              quantity: parseFloat(item.quantity).toFixed(2),
              effective_date: moment(item.effective_date).format("DD/MM/YYYY HH:mm"),
              id: id,
              concept: concept,
              order_id: item.order_id,
              code: code,
              type: type,
            });
          }
          this.dialogHistory = true;
        } else {
          this.$toast.error(data.error);
        }
      } catch (error) {
        console.error("Error loading warehouse history:", error);
        this.$toast.error("Error al cargar el historial del almacén");
      }
    },

    async downloadHistoryXLSX() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Historial de Movimientos");

      worksheet.columns = [
        { header: "Fecha", key: "effective_date", width: 22 },
        { header: "Cantidad", key: "quantity", width: 12 },
        { header: "Concepto", key: "concept", width: 18 },
        { header: "Codigo", key: "code", width: 22 },
      ];

      this.itemsHistory.forEach((row) => {
        worksheet.addRow({
          effective_date: row.effective_date,
          quantity: parseFloat(row.quantity),
          concept: row.concept,
          code: row.code,
        });
      });

      // Estilo encabezado
      worksheet.getRow(1).font = { bold: true };

      const safeName = this.historyName.replace(/[\\/*?[\]:]/g, "_").slice(0, 50);
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Historial_${safeName}.xlsx`;
      link.click();
    },

    viewOrigin(item) {
      if (item.type == 1) {
        this.showInvoice(item.id, true);
      }
      if (item.type == 2) {
        let route = this.$router.resolve({
          name: "ViewTransfer",
          params: { id: item.id },
        });
        window.open(route.href);
      }
      if (item.type == 3) {
        let route = this.$router.resolve({
          name: "ViewAdjustment",
          params: { id: item.id },
        });
        window.open(route.href);
      }
      if (item.type == 4) {
        const routeData = this.$router.resolve({
          name: "ComboTransformation",
          query: { id: item.id },
        });
        window.open(routeData.href, "_blank");
      }
      if (item.type == 5) {
        this.showNote(item.id, true);
      }
      if (item.type == 7) {
        let route = this.$router.resolve({
          name: "ViewOutflows",
          params: { id: item.id },
        });

        window.open(route.href, "_blank");
      }
      if (item.type == 8) {
        this.viewReception(item.order_id, item.id, true);
      }
    },

    // ================================
    // MÉTODOS DE TRANSFORMACIÓN
    // ================================

    transform(article) {
      // Validar que haya un almacén específico seleccionado
      if (
        !this.filters.warehouse ||
        !this.filters.warehouse.id ||
        this.filters.warehouse.id === "all" ||
        this.filters.warehouse.id === "-1"
      ) {
        this.$toast.warning(
          "Debe seleccionar un almacén específico para transformar artículos"
        );
        return;
      }

      const quantity = article.total_quantity || article.quantity || 0;

      if (quantity == 0 && !article.negative_sale) {
        this.$toast.warning("El artículo no cuenta con existencia para transformar!");
        return;
      }

      this.itemTransform = {
        article_id: article.item_id,
        business_unit_id: this.filters.business,
        location_id: this.filters.location.id,
        warehouse_id: this.filters.warehouse.id,
        quantity_available: quantity,
        inventory_product: article.inventory_product,
        negative_sale: article.negative_sale,
      };
      this.dialogTransform = true;
    },

    closeTransform(value) {
      if (value == true) {
        this.getArticlesInWarehouse(this.filters);
      }
      this.dialogTransform = false;
    },

    // ================================
    // MÉTODOS DE FILTROS Y VALIDACIÓN
    // ================================

    async loadFilterData() {
      try {
        // Cargar datos de filtros si no están cargados
        if (this.units.length === 0) {
          const resultUnits = await this.api_Get("inventory/units");
          this.units = await resultUnits.json();
          this.units.unshift({ id: 0, name: "TODO" });
        }

        if (this.itemTypes.length === 0) {
          const resultItemTypes = await this.api_Get("inventory/itemTypes");
          this.itemTypes = await resultItemTypes.json();
          this.itemTypes.unshift({ id: 0, name: "TODO" });
        }

        if (this.taxes.length === 0) {
          const taxesRequest = await this.api_Get("accounting/taxes");
          this.taxes = await taxesRequest.json();
          this.taxes.unshift({ id: 0, name: "TODO" });
        }

        // if (this.categorys.length === 0) {
        //   const categoryRequest = await this.api_Get("inventory/categories");
        //   const allCategories = await categoryRequest.json();
        //   // Solo mostrar categorías raíz (sin categoría padre)
        //   this.categorys = allCategories.filter(
        //     (category) => category.parent_category_id == null
        //   );
        //   console.log(this.categorys )
        //   this.categorys.unshift({ id: 0, name: "TODO" });
        // }

        if (this.accountCategorys.length === 0) {
          const resultAccounts = await this.api_Get("accounting/account_categories");
          this.accountCategorys = await resultAccounts.json();
          this.accountCategorys.unshift({ id: 0, name: "TODO" });
        }
      } catch (error) {
        console.error("Error al cargar datos de filtros:", error);
      }
    },

    updateFiltersData() {
      // Crear filters_data para mostrar chips correctamente
      this.filters_data = {};

      // Mapear los filtros activos con sus nombres
      const filterMappings = {
        unit: { description: "Unidad: ", items: this.units || [] },
        item_type: { description: "Tipo: ", items: this.itemTypes || [] },
        item_category: { description: "Categoría: ", items: this.categorys || [] },
        account_category: { description: "Cuenta: ", items: this.accountCategorys || [] },
        tax_type: { description: "Impuesto: ", items: this.taxes || [] },
        inventory_product: {
          description: "Inventariable: ",
          items: [
            { id: 0, name: "AMBOS" },
            { id: 1, name: "SI" },
            { id: 2, name: "NO" },
          ],
        },
        negative_sale: {
          description: "Valores negativos: ",
          items: [
            { id: 0, name: "AMBOS" },
            { id: 1, name: "SI" },
            { id: 2, name: "NO" },
          ],
        },
      };

      // Generar filters_data para cada filtro activo
      Object.keys(this.computeFilters).forEach((key) => {
        if (this.computeFilters[key] > 0 && filterMappings[key]) {
          const mapping = filterMappings[key];
          const selectedItem = mapping.items.find(
            (item) => item.id === this.computeFilters[key]
          );

          if (selectedItem) {
            this.filters_data[key] = {
              description: mapping.description,
              name: selectedItem.name,
            };
          }
        }
      });
    },

    resetFilter(key) {
      // Resetear el filtro específico
      this.computeFilters[key] = 0;

      // Actualizar filters_data
      this.updateFiltersData();

      // Recargar datos con los filtros actualizados
      if (this.filters && this.filters.warehouse && this.filters.warehouse.id) {
        this.getArticlesInWarehouse(this.filters, true);
      }
    },

    filtrar(filtros) {
      this.computeFilters = filtros.filters_id;
      this.filters_data = filtros.filters_data;
      this.dialogFilters = false;

      // Resetear paginación al aplicar filtros
      this.pagination.current_page = 1;

      // Combinar filtros de HeaderFilters (lastFilters) con los de ArticleFilters
      let combinedFilters = this.filters;

      // Si tenemos lastFilters guardados de HeaderFilters, usarlos como base
      if (this.lastFilters && Object.keys(this.lastFilters).length > 0) {
        combinedFilters = { ...this.lastFilters };

        // Actualizar this.filters con los filtros combinados para mantener consistencia
        this.filters = combinedFilters;
      }

      // Recargar datos con los filtros combinados
      if (combinedFilters && combinedFilters.warehouse && combinedFilters.warehouse.id) {
        this.getArticlesInWarehouse(combinedFilters, true);
      } else {
        console.warn("No hay almacén seleccionado para aplicar filtros");
      }
    },

    // ================================
    // MÉTODOS DE PAGINACIÓN
    // ================================

    onPageChange(page) {
      this.pagination.current_page = page;
      this.getArticlesInWarehouse(this.filters, false);
    },

    onItemsPerPageChange(itemsPerPage) {
      this.pagination.per_page = itemsPerPage;
      this.pagination.current_page = 1;
      this.getArticlesInWarehouse(this.filters, false);
    },

    validateFilter(item) {
      if (
        this.computeFilters.account_category != 0 &&
        item.account_category_id != this.computeFilters.account_category
      ) {
        return true;
      }
      if (
        this.computeFilters.item_category.length > 0 &&
        this.computeFilters.item_category.includes(item.item_category_id) == false
      ) {
        return true;
      }
      if (
        this.computeFilters.item_type != 0 &&
        item.item_type_id != this.computeFilters.item_type
      ) {
        return true;
      }
      if (
        this.computeFilters.tax_type != 0 &&
        item.tax_type_id != this.computeFilters.tax_type
      ) {
        return true;
      }
      if (this.computeFilters.unit != 0 && item.unit_id != this.computeFilters.unit) {
        return true;
      }
      // Filtro negative_sale: 0=AMBOS, 1=SI, 2=NO
      if (this.computeFilters.negative_sale == 1 && item.negative_sale == false) {
        return true;
      }
      if (this.computeFilters.negative_sale == 2 && item.negative_sale == true) {
        return true;
      }
      // Filtro inventory_product: 0=AMBOS, 1=SI, 2=NO
      if (this.computeFilters.inventory_product == 1 && item.inventory_product == false) {
        return true;
      }
      if (this.computeFilters.inventory_product == 2 && item.inventory_product == true) {
        return true;
      }

      return false;
    },

    // ================================
    // MÉTODOS DE EXPORTACIÓN
    // ================================

    async exportExcel() {
      try {
        this.loading = true;

        // Preparar datos de solicitud sin paginación
        const requestData = {
          date: this.filters.dateEnd,
          business_unit_id: this.filters.business,
          location_id: this.filters.location.value,
          warehouse_id: this.filters.warehouse.id,
          is_parent: this.filters.warehouse.isParent || false,
          is_now: true,
          search: this.search || "",
          category_id:
            this.computeFilters.item_category.length > 0
              ? this.computeFilters.item_category.join(",")
              : null,
          item_type_id:
            this.computeFilters.item_type > 0 ? this.computeFilters.item_type : null,
          unit_id: this.computeFilters.unit > 0 ? this.computeFilters.unit : null,
          account_category_id:
            this.computeFilters.account_category > 0
              ? this.computeFilters.account_category
              : null,
          tax_type_id:
            this.computeFilters.tax_type > 0 ? this.computeFilters.tax_type : null,
          inventory_product: this.computeFilters.inventory_product,
          negative_sale: this.computeFilters.negative_sale,
          show_all: this.showAll || false,
        };

        // Llamar al nuevo endpoint para exportación
        const request = await this.api_Post("inventory/inventory_value_export", requestData);
        const data = await request.json();

        if (request.status !== 200) {
          this.$toast.error("Error al obtener datos para exportación");
          return;
        }

        const allItems = data.data || [];

        if (allItems.length === 0) {
          this.$toast.warning("No hay datos para exportar");
          return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Inventario");

        worksheet.columns = [
          { header: "ID", key: "id", width: 10 },
          { header: "Codigo de barras", key: "code", width: 20 },
          { header: "Nombre articulo", key: "item_name", width: 30 },
          { header: "Tipo de producto", key: "item_type", width: 20 },
          { header: "Unidad", key: "unit", width: 15 },
          { header: "Categoria del item", key: "item_category", width: 20 },
          { header: "Categoria del catalogo", key: "catalogue_category", width: 20 },
          { header: "Categoria de cuentas", key: "account_category", width: 20 },
          { header: "Costo", key: "cost_price", width: 15 },
          { header: "Precio venta", key: "sale_price", width: 15 },
          { header: "Disponibilidad", key: "quantity", width: 15 },
          { header: "Almacenes", key: "warehouses", width: 30 },
        ];

        for (let row of allItems) {
          // Procesar distribución de almacenes
          let warehouseDistribution = [];
          let totalQuantity = 0;

          if (this.filters.warehouse.id === 0) {
            // Todos los almacenes
            warehouseDistribution = this.processAllWarehouses(row);
            totalQuantity = warehouseDistribution.reduce(
              (sum, w) => sum + (w.quantity || 0),
              0
            );
          } else if (this.filters.warehouse.isParent) {
            // Almacén padre
            warehouseDistribution = this.processParentWarehouse(row);
            totalQuantity = warehouseDistribution.reduce(
              (sum, w) => sum + (w.quantity || 0),
              0
            );
          } else {
            // Almacén individual
            const available = row.item_in_warehouses?.filter(
              (element) => element.warehouse_id == this.filters.warehouse.id
            );
            totalQuantity = available.length > 0 ? available[0].quantity : 0;

            if (available.length > 0) {
              warehouseDistribution = [
                {
                  warehouse_id: this.filters.warehouse.id,
                  warehouse_name: this.filters.warehouse.name,
                  quantity: totalQuantity,
                },
              ];
            }
          }

          const currency = this.getBusinessCurrency();
          const prices = row.item_currencies.find(
            (element) => element.currency_id === currency.currency_id
          );
          const warehouses =
            warehouseDistribution?.map((w) => w.warehouse_name).join("; ") || "";

          const costPrice = prices?.cost_price || 0;

          worksheet.addRow({
            id: row.item_id,
            code: row.code || "NO DEFINIDO",
            item_name: row.item_name,
            item_type: row.item_type_name,
            unit: row.unit_name,
            item_category: row.item_category_name,
            catalogue_category: row.catalogue_category_name,
            account_category: row.account_category_name,
            cost_price: parseFloat(costPrice),
            sale_price: parseFloat(prices?.sale_price || 0),
            quantity: totalQuantity,
            warehouses: warehouses,
          });
        }

        // Estilizar encabezados
        worksheet.getRow(1).eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center" };
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${this.lastFilters?.location?.text || "Inventario"} - ${this.lastFilters?.warehouse?.name || "Almacén"} - ${moment().format("DD/MM/YYYY")}.xlsx`;
        link.click();

        this.$toast.success(`Excel exportado exitosamente con ${allItems.length} registros`);

      } catch (error) {
        console.error("Error en exportExcel:", error);
        this.$toast.error("Error al exportar Excel");
      } finally {
        this.loading = false;
      }
    },

    async downloadPDF() {
      try {
        this.loading = true;

        // Preparar datos de solicitud sin paginación
        const requestData = {
          date: this.filters.dateEnd,
          business_unit_id: this.filters.business,
          location_id: this.filters.location.value,
          warehouse_id: this.filters.warehouse.id,
          is_parent: this.filters.warehouse.isParent || false,
          is_now: true,
          search: this.search || "",
          category_id:
            this.computeFilters.item_category.length > 0
              ? this.computeFilters.item_category.join(",")
              : null,
          item_type_id:
            this.computeFilters.item_type > 0 ? this.computeFilters.item_type : null,
          unit_id: this.computeFilters.unit > 0 ? this.computeFilters.unit : null,
          account_category_id:
            this.computeFilters.account_category > 0
              ? this.computeFilters.account_category
              : null,
          tax_type_id:
            this.computeFilters.tax_type > 0 ? this.computeFilters.tax_type : null,
          inventory_product: this.computeFilters.inventory_product,
          negative_sale: this.computeFilters.negative_sale,
          show_all: this.showAll || false,
        };

        // Llamar al nuevo endpoint para exportación
        const request = await this.api_Post("inventory/inventory_value_export", requestData);
        const data = await request.json();

        if (request.status !== 200) {
          this.$toast.error("Error al obtener datos para exportación");
          return;
        }

        const allItems = data.data || [];

        if (allItems.length === 0) {
          this.$toast.warning("No hay datos para exportar");
          return;
        }

        // Procesar los datos para el PDF
        const processedItems = [];
        for (let row of allItems) {
          // Procesar distribución de almacenes
          let warehouseDistribution = [];
          let totalQuantity = 0;

          if (this.filters.warehouse.id === 0) {
            // Todos los almacenes
            warehouseDistribution = this.processAllWarehouses(row);
            totalQuantity = warehouseDistribution.reduce(
              (sum, w) => sum + (w.quantity || 0),
              0
            );
          } else if (this.filters.warehouse.isParent) {
            // Almacén padre
            warehouseDistribution = this.processParentWarehouse(row);
            totalQuantity = warehouseDistribution.reduce(
              (sum, w) => sum + (w.quantity || 0),
              0
            );
          } else {
            // Almacén individual
            const available = row.item_in_warehouses?.filter(
              (element) => element.warehouse_id == this.filters.warehouse.id
            );
            totalQuantity = available.length > 0 ? available[0].quantity : 0;

            if (available.length > 0) {
              warehouseDistribution = [
                {
                  warehouse_id: this.filters.warehouse.id,
                  warehouse_name: this.filters.warehouse.name,
                  quantity: totalQuantity,
                },
              ];
            }
          }

          // Agregar el item procesado
          processedItems.push({
            ...row,
            total_quantity: totalQuantity,
            quantity: totalQuantity,
            warehouse_distribution: warehouseDistribution
          });
        }

        const doc = new jsPDF();

        const title = `Inventario al día de hoy - ${moment().format("DD/MM/YYYY")}`;
        const subtitle = `${this.lastFilters?.location?.text || ""} - ${this.lastFilters?.warehouse?.name || ""
          }`;

        const pageContent = (data) => {
          // Header
          doc.setFontSize(16);
          doc.text(title, doc.internal.pageSize.getWidth() / 2, 20, { align: "center" });
          doc.setFontSize(12);
          doc.text(subtitle, doc.internal.pageSize.getWidth() / 2, 30, { align: "center" });

          // Footer
          const str = "Página " + data.pageNumber;
          doc.setFontSize(10);
          const pageHeight =
            doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
          doc.text(str, data.settings.margin.left, pageHeight - 10);
        };

        this.generatePDFContent(doc, processedItems, pageContent);

        doc.save(
          `${this.lastFilters?.location?.text || "Inventario"} - ${this.lastFilters?.warehouse?.name || "Almacén"
          } - ${moment().format("DD/MM/YYYY")}.pdf`
        );

        this.$toast.success(`PDF generado exitosamente con ${allItems.length} registros`);

      } catch (error) {
        console.error("Error en downloadPDF:", error);
        this.$toast.error("Error al generar PDF");
      } finally {
        this.loading = false;
      }
    },

    generatePDFContent(doc, inventoryItems, pageContent) {
      const columns = [
        { header: "ID", dataKey: "item_id" },
        { header: "Nombre articulo", dataKey: "item_name" },
        { header: "Unidad", dataKey: "unit_name" },
        { header: "Tipo", dataKey: "item_type_name" },
        { header: "Disponibilidad", dataKey: "quantity" },
      ];

      const rows = inventoryItems.map((item) => ({
        item_id: item.item_id,
        item_name: item.item_name,
        unit_name: item.unit_name,
        item_type_name: item.item_type_name,
        quantity: item.total_quantity || item.quantity,
      }));

      const currency = this.getBusinessCurrency();
      const totalInventory = inventoryItems.reduce(
        (total, item) => total + this.calculateItemValue(item),
        0
      );

      doc.autoTable({
        head: [columns.map((col) => col.header)],
        body: rows.map((row) => columns.map((col) => row[col.dataKey])),
        startY: 40,
        styles: { fontSize: 10 },
        headStyles: { fillColor: [22, 160, 133] },
        theme: "striped",
        margin: { top: 35 },
        didDrawPage: pageContent,
      });

      const finalY = doc.autoTable.previous.finalY + 10;
      doc.setFontSize(16);
      doc.text(
        `Valor total del inventario: ${this.currencyFormat(totalInventory.toFixed(2))} ${currency.currency_code
        }`,
        14,
        finalY
      );
    },

    getTotalCost() {
      return this.currencyFormat(
        this.getInventory.reduce((sum, item) => {
          return sum + this.calculateItemValue(item);
        }, 0)
      );
    },

    // ================================
    // MÉTODOS DE COMPATIBILIDAD
    // ================================

    currencyFormat(value) {
      if (!value && value !== 0) return "0.00";
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    deleteDiacriticos(texto) {
      if (!texto) return "";
      return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
  },
};
</script>

<style scoped>
/* ================================
   ESTILOS PRINCIPALES
   ================================ */

.inventory-title-section {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

/* ================================
   ESTILOS DE ALERTAS Y CARDS
   ================================ */

.warehouse-info-alert {
  border-radius: 12px !important;
  border-left: 6px solid var(--v-info-base) !important;
  transition: all 0.3s ease;
}

.warehouse-info-alert:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.2);
}

/* ================================
   ESTILOS DE LA TABLA
   ================================ */

.inventory-table-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
}

.inventory-data-table {
  background: white;
}

.inventory-toolbar {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid #dee2e6;
}

.toolbar-title {
  color: var(--v-secondary-base);
  font-weight: 500;
  display: flex;
  align-items: center;
}

.search-field {
  max-width: 300px;
  transition: all 0.3s ease;
}

.search-field.v-input--is-focused {
  transform: scale(1.02);
}

/* ================================
   ESTILOS DE DISTRIBUCIÓN DE ALMACENES
   ================================ */

.warehouse-distribution-card {
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
  border-left: 4px solid var(--v-primary-base);
  margin: 8px 16px;
  border-radius: 8px;
}

.warehouse-distribution-header {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-bottom: 1px solid #90caf9;
  color: var(--v-primary-base);
}

.warehouse-distribution-table {
  background: white;
  border-radius: 0 0 8px 8px;
}

.warehouse-distribution-row {
  transition: background-color 0.3s ease;
}

.warehouse-distribution-row:hover {
  background: linear-gradient(135deg,
      rgba(25, 118, 210, 0.05) 0%,
      rgba(25, 118, 210, 0.1) 100%);
}

/* ================================
   ESTILOS DEL FOOTER
   ================================ */

.inventory-footer {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-top: 2px solid #dee2e6;
  padding: 16px;
  margin: 0;
}

.total-label {
  font-weight: bold;
  color: #607d8b;
  font-size: 24px;
  display: block;
}

.total-amount {
  font-size: 20px;
  font-weight: bold;
  color: var(--v-success-base);
  text-align: right;
}

.currency-info {
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  color: #666;
}

/* ================================
   ESTILOS DEL HISTORIAL
   ================================ */

.history-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.history-header {
  background: linear-gradient(135deg,
      var(--v-primary-base) 0%,
      var(--v-primary-darken1) 100%);
  color: white;
}

.history-article-info {
  text-align: center;
  padding: 16px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  margin: 0 16px;
}

.article-name {
  color: var(--v-secondary-base);
  margin-bottom: 8px;
}

.article-details {
  font-size: 14px;
}

.history-table {
  border-radius: 8px;
  overflow: hidden;
}

/* ================================
   ESTILOS DE ENLACES
   ================================ */

.origin-link {
  color: var(--v-primary-base);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  border-bottom: 1px solid transparent;
}

.origin-link--hover {
  color: var(--v-error-base);
  text-decoration: underline;
  border-bottom-color: var(--v-error-base);
  transform: translateY(-1px);
}

/* ================================
   RESPONSIVE DESIGN
   ================================ */

@media (max-width: 960px) {
  .inventory-title-section {
    flex-direction: column;
    gap: 12px;
  }

  .inventory-toolbar {
    flex-direction: column;
    gap: 16px;
    padding: 16px;
  }

  .search-field {
    max-width: none;
    width: 100%;
  }

  .warehouse-distribution-card {
    margin: 4px 8px;
  }
}

@media (max-width: 600px) {
  .warehouse-distribution-header {
    padding: 12px 16px;
  }

  .warehouse-distribution-table {
    font-size: 14px;
  }

  .history-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px);
  }
}

/* ================================
   ANIMACIONES
   ================================ */

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.inventory-table-card {
  animation: fadeInUp 0.6s ease-out;
}

.warehouse-distribution-card {
  animation: fadeInUp 0.4s ease-out;
}

/* ================================
   EFECTOS HOVER
   ================================ */

.v-btn:not(.v-btn--disabled):hover {
  transform: translateY(-1px);
  transition: transform 0.2s ease;
}

.v-chip {
  transition: all 0.3s ease;
}

.v-chip:hover {
  transform: scale(1.05);
}

.debounce-progress-bar-container {
  width: 100%;
  height: 3px;
  background-color: transparent;
  overflow: hidden;

  /* 1. Mueve la barra para que inicie donde empieza el texto (compensando el padding interno) */
  margin-left: 12px;

  /* 2. Reduce el ancho total para que termine donde acaba el texto/iconos */
  /* El 100% es el ancho de todo el v-text-field. Necesitas restar el margen izquierdo (12px) 
       y todo el espacio de los iconos de la derecha (al menos 36px por el mdi-magnify/clearable). */
  width: calc(100% - 48px);
  /* Ajusta 48px si es necesario */

  /* 3. Pégalo verticalmente */
  margin-top: -3px;
}

/* El elemento interno que se llena */
.debounce-progress-bar {
  height: 100%;
  background-color: #1976D2;
  transition: width 0.05s linear;
}
</style>
